// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3L3T6","right":"styles_right__1-f8y"};